/**@jsx jsx */
import { jsx } from "theme-ui";
import { Link } from "gatsby";
import { Hamburger, Times, Location, Phone } from "./Icons";
import { AppContext } from "../context/AppContext";
import { useContext } from "react";
import logo from "../images/first-virginia-logo.svg";
import { colors } from "../gatsby-plugin-theme-ui/colors";

interface NavbarProps {
	stsLayout?: boolean;
}

const MainHeader = ({ stsLayout }: NavbarProps) => {
	const { isSidebarOpen, openSidebar, closeSidebar } = useContext(AppContext);
	return (
		<header
			sx={{
				backgroundColor: "white",
				zIndex: 2000,
				position: "sticky",
				top: 0,
				boxShadow: !isSidebarOpen && "0px 2px 4px #0000007A",
				width: "100%",
				maxWidth: "100%",
				px: ["20px", null, null, null, "0px"],
				borderBottomColor: "moneyGreen",
				borderBottomStyle: "solid",
				borderBottomWidth: ["4px", null, null, "5px", "5px"],
			}}
		>
			<nav
				sx={{
					maxWidth: "1180px",
					px: ["initial", null, null, "32px", null],
					mx: "auto",
					height: "70px",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Link to="/">
					<img
						src={logo}
						alt="First Virginia Loans Logo"
						sx={{ width: ["160px", null, null, null, "200px"] }}
					/>
				</Link>
				{!stsLayout && (
					<ul
						sx={{ display: "flex", alignItems: "center", gap: [5, null, null, 3, 5] }}
					>
						{/* mobile - hamburger menu */}
						{!isSidebarOpen ? (
							<button
								onClick={openSidebar}
								sx={{
									display: ["block", null, null, "none", "none"],
									background: "none",
									border: "none",
									"&:focus": { outline: "none" },
								}}
							>
								<Hamburger fill={colors.forestGreen} />
							</button>
						) : (
							<button
								onClick={closeSidebar}
								sx={{
									display: ["block", null, null, null, "none"],
									background: "none",
									border: "none",
									"&:focus": { outline: "none" },
								}}
							>
								<Times fill={colors.forestGreen} />
							</button>
						)}
						<li
							sx={{
								display: ["none", null, null, "flex"],
								alignItems: "center",
								gap: 2,
							}}
						>
							<Location fill={colors.moneyGreen} />
							<a
								sx={{ variant: "text.navLink" }}
								href="https://www.google.com/maps/search/?api=1&query=36.85667059967011%2C-76.20202207151335&query_place_id=ChIJC6NlHUKWuokRe2iY874ih8A"
								target="_blank"
							>
								Locations
							</a>
						</li>
						<li
							sx={{
								display: ["none", null, null, "flex"],
								alignItems: "center",
								gap: 2,
							}}
						>
							<Phone fill={colors.moneyGreen} />
							<a
								sx={{
									variant: "text.navLink",
									display: ["none", null, null, "inline"],
								}}
								href="tel:855-920-9800"
							>
								855-920-9800
							</a>
						</li>
					</ul>
				)}
			</nav>
		</header>
	);
};

export default MainHeader;
